import type { SportsSeoState } from './types';

export const defaultState: SportsSeoState = {
  hasPreloaded: false
};
